import { useEffect, useState } from 'react';
import markerSDK, { MarkerSdk } from '@marker.io/browser';
import { ENVIRONMENT, MARKER_IO_PROJECT_ID } from '@/lib/constants';
import useUserStore from '@/store/useUserStore';

const ENABLE_MARKER_IO_WIDGET = ENVIRONMENT !== 'production' || import.meta.env.DEV;

const useMarkerIo = () => {
  const [widget, setWidget] = useState<MarkerSdk>();

  const { user } = useUserStore();

  const load = async () => {
    if (MARKER_IO_PROJECT_ID) {
      const widget = await markerSDK.loadWidget({
        project: MARKER_IO_PROJECT_ID,
      });

      setWidget(widget);
    }
  };

  const setReporter = () => {
    if (widget && user) {
      const { email, firstName, lastName } = user;

      widget.setReporter({ email, fullName: `${firstName} ${lastName}` });
    }
  };

  useEffect(() => {
    if (!widget && ENABLE_MARKER_IO_WIDGET) {
      load();
    }
  }, [widget]);

  return {
    widget,
    load,
    setReporter,
  };
};

export { useMarkerIo };
